import { GxEAIChatMessage } from "../chat/types";

export enum GxEAITicketStatus {
  open = 'open',
  diagnosing = 'diagnosing',
  diagnosed = 'diagnosed',
  fixing = 'fixing',
  fixed = 'fixed',
  closed = 'closed'
}
type GxEAITicketStatusType = keyof typeof GxEAITicketStatus;

export type GxEAITicket = {
  id: string;
  title: string;
  priority: "low" | "medium" | "high";
  status: GxEAITicketStatusType;
  detail?: GxEAITicketDetail;
  chat?: GxEAITicketChat;
  diagnosing?: GxEAITicketLogging
  diagnostic?: GxEAITicketDiagnostic;
  plan?: GxEAITicketPlan;
  project: {
    workspace: string;
  };
  repo?: string;
};

export type GxEAITicketDetail = {
  description: string;
  body: string;

  url: string;

  reporter: string;
  created: Date;
  updated: Date;
  domain: string;
  type: "bug" | "feature";

  operatingSystem?: string;
  browser?: string;
  applicationVersion?: string;

  files?: {
    name: string;
    url: string;
  }[];
};

export type GxEAITicketChat = {
  id: string;
  messages: GxEAIChatMessage[];
};

export type GxEAITicketDiagnostic = {
  analysis: string;
};

export type GxEAITicketPlan = {
  changes: GxEAITicketPlanChange[];
};

export type GxEAITicketPlanChange = {
  comment: string;
  sourceFile?: string;
  modifiedFile?: string;
};

export type GxEAITicketLogging = {
  streaming: string[];
}